import React from 'react';
import { Link } from 'react-router-dom';

export default () => {
  return (
    <div className="Footer-Content">

      <div className='Footer-Section'>
        <div className="Heading">Customer Care</div>
        <Link className="Link" to='/drt'>Help Center</Link>
        <Link className="Link" to='/'>How to Buy</Link>
        <Link className="Link" to='/'>Track your Order</Link>
        <Link className="Link" to='/'>Returns & Refunds</Link>
      </div>

      <div className='Footer-Section'>
        <div className="Heading">ADENZO</div>
        <Link className="Link" to='/'>About Us</Link>
        <Link className="Link" to='/'>Contact Us</Link>
        <Link className="Link" to='/'>Privacy Policy</Link>
        <Link className="Link" to='/'>Terms & Conditions</Link>
      </div>

      <div className='Footer-Section'>
        <div className="Heading">PAYMENT METHODS</div>
        <Link className="Link" to='/'>Visa</Link>
        <Link className="Link" to='/'>M-Pesa</Link>
        <Link className="Link" to='/'>Mastercard</Link>
        <Link className="Link" to='/'>Cash on Delivery</Link>
      </div>

      <div className='Footer-Section'>
        <div className="Heading">FEEDBACK</div>
        <Link className="Link" to='/'>fb@adenzo.co.ke</Link>
        <Link className="Link" to='/'>+254 711 582 200</Link>
        <Link className="Link" to='/'>Krishna Plaza, Westlands</Link>
      </div>

      <div className='Footer-Section'>
        <div className="Heading">GET IN TOUCH</div>
        <Link className="Link" to='/'>Twitter</Link>
        <Link className="Link" to='/'>Facebook</Link>
        <Link className="Link" to='/'>Instagram</Link>
      </div>

    </div>
  );

}
